import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { BASE_URL } from '../apiConfig';

const formatDate = () => {
  const options = { day: '2-digit', month: 'short' };
  const date = new Date().toLocaleDateString('en-GB', options);
  return date.replace(/ /g, '-');
};

export const downloadLeadsReport = createAsyncThunk(
  'downloadLeads/downloadReport',
  async ({ jwtBearer, type }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}pipeline/leads/download/?type=${type}`, {
        headers: {
          Authorization: `Bearer ${jwtBearer}`,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${type}_${formatDate()}.xlsx`;
      link.click();

      URL.revokeObjectURL(url);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const downloadLeadsSlice = createSlice({
  name: 'downloadLeads',
  initialState: {
    isDownloadingLeads: false,
    isErrorLeadsDownload: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadLeadsReport.pending, (state) => {
        state.isDownloadingLeads = true;
        state.isErrorLeadsDownload = false;
      })
      .addCase(downloadLeadsReport.fulfilled, (state) => {
        state.isDownloadingLeads = false;
      })
      .addCase(downloadLeadsReport.rejected, (state, action) => {
        state.isDownloadingLeads = false;
        state.isErrorLeadsDownload = true;
        console.error('Download failed:', action.payload);
      });
  },
});

export default downloadLeadsSlice.reducer;
